import React, { useState } from "react";
import { handleReservation } from "../../utils/reservationUtils";
import { formatHorario } from "../../utils/timeUtils";
import { toast } from "react-toastify";
import "./styles.css";
import Icon from "../Icon";

const Modal = ({ selected, close }) => {
  const [reserverName, setReserverName] = useState("");

  const handleReserve = async () => {
    if (!reserverName.trim()) {
      toast.error("Informe um nome para agendar a reserva");
    } else {
      await handleReservation(selected.roomId, selected._id, reserverName, close);
      setReserverName("");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button className="close-icon" onClick={() => {
          close();
        }}>
          <Icon name="close" size={24} color="#Ff0000" />
        </button>
        
        <div className="modal-content">
          <h3>Agendamento</h3>
          <h3>{selected.roomName}</h3>
          <h2>Confirmar Reserva</h2>
          
          <p className="modal-description">
            Você deseja reservar o horário <strong>{formatHorario(selected.horario, selected.roomName)}</strong> em{" "}
            <strong>{selected.roomName}</strong>?
          </p>
          
          <div className="modal-input">
            <input
              id="reserver-name"
              type="text"
              value={reserverName}
              onChange={(e) => setReserverName(e.target.value)}
              placeholder="Informe o nome para agendar a reserva"
            />
          </div>
        </div>

        <div className="modal-buttons">
          <button className="button-confirm" onClick={handleReserve}>
            Agendar
          </button>
          <button className="button-cancel" onClick={close}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;